import { Link, useNavigate } from "react-router-dom";
import React, { useCallback, useEffect, useState } from "react";
import { INDIAN_MSME_USER_TYPE } from "../utils/Constants";
import { getCookie } from "../utils/CookieAction";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../stores";
import { toast } from "react-toastify";
import { Messages } from "../utils/Messages";
import profileAction from "../stores/actions/profileAction";

const Sidebar = ({ setMobileToggle }: any) => {
  const dispatch = useDispatch<any>();

  const navigate = useNavigate();
  const { profileDetails } = useSelector((state: RootState) => state.auth);

  const pageUrl = window.location.href;

  const [userType, setUserType] = useState<any>("");
  const [activeMenu, setActiveMenu] = useState<any>(null);
  const [activeSubmenu, setActiveSubmenu] = useState<any>(null);
  const getProfileLocalStorage = () => {
    const data = getCookie(INDIAN_MSME_USER_TYPE);
    if (data) {
      const parsing = JSON.parse(data);
      setUserType(parsing);
    }
  };

  const getProfile = useCallback(async () => {
    await dispatch(profileAction.getProfile());
  }, []);

  useEffect(() => {
    getProfile();
  }, [getProfile]);

  const handleMenuClick = (menuIndex: any) => {
    if (activeMenu === menuIndex) {
      localStorage.setItem("activeMenu", "");
      localStorage.setItem("activeSubmenu", "");
      setActiveMenu(null);
      setActiveSubmenu(null);
    } else {
      setActiveMenu(menuIndex);
      localStorage.setItem("activeMenu", menuIndex);
      setActiveSubmenu(null);
    }
  };

  useEffect(() => {
    const activeM: any = localStorage.getItem("activeMenu");
    const subActiveM: any = localStorage.getItem("activeSubMenu");

    if (activeM) {
      setActiveMenu(parseInt(activeM));
    } else {
      setActiveMenu(0);
    }
    setActiveSubmenu(parseInt(subActiveM));
  }, []);

  useEffect(() => {
    getProfileLocalStorage();
  }, [getProfileLocalStorage]);

  const SidebarData = [
    {
      label: "Dashboard",
      icon: "menu-icon tf-icons bx bx-home-circle",
      path: "/dashboard",
      visible: true,
      menuActive: pageUrl.includes("dashboard"),
      moduleEnable: true,
    },
    {
      label: "Profile",
      icon: "menu-icon tf-icons bx bx-user",
      path: "/profile",
      visible: true,
      menuActive: pageUrl.includes("profile"),
      moduleEnable: true,
    },
    {
      label: "My Orders",
      icon: "menu-icon tf-icons bx bx-category",
      visible: true,
      menuActive: pageUrl.includes("orders/pending"),
      moduleEnable: profileDetails?.account_status === "ACTIVATE",
      submenu: [
        {
          label: "Order Placed",
          path: "/my-orders/pending",
          subMenuActive: pageUrl.includes("po-list/pending"),
        },
        {
          label: "Dispatch Status",
          path: "/my-orders/placed",
          subMenuActive: pageUrl.includes("my-orders/placed"),
        },
        {
          label: "Received Status",
          path: "/my-orders/dispatch",
          subMenuActive: pageUrl.includes("my-orders/dispatch"),
        },
      ],
    },
  ];

  return (
    <aside
      id="layout-menu"
      className="layout-menu menu-vertical menu bg-menu-theme 
       bg-green border-shadow-right-green">
      <div className="app-brand demo ">
        <Link to="/dashboard" className="app-brand-link">
          <img
            src={require("../assets/logo.png")}
            style={{
              width: "100%",
              objectFit: "contain",
              backgroundColor: "#fff",
            }}
            className="my-3 p-2"
          />
        </Link>
        <a
          onClick={() => setMobileToggle("off")}
          className="layout-menu-toggle menu-link text-large ms-auto bg-green">
          <i className="bx bx-chevron-left bx-sm align-middle"></i>
        </a>
      </div>

      <div className="menu-inner-shadow"></div>

      <ul className="menu-inner py-1 ps scrollable-container">
        {SidebarData.map((data: any, menuIndex: number) => {
          return (
            <li
              className={`menu-item ${data.visible ? "" : "d-none"} ${
                data.menuActive ? "active" : ""
              } ${
                data.moduleEnable
                  ? activeMenu === menuIndex
                    ? "open"
                    : ""
                  : "disabled"
              }`}
              key={menuIndex}>
              <div
                className={`menu-link cursor-pointer text-white ${
                  data.submenu ? "menu-toggle" : ""
                }`}
                onClick={() => {
                  handleMenuClick(menuIndex);
                  data.moduleEnable
                    ? navigate(data.path)
                    : toast.error(Messages.moduleDisable);
                }}>
                <i className={data.icon}></i>
                <div className="text-truncate" data-i18n={data.label}>
                  {data.label}
                </div>
              </div>

              {data.submenu && activeMenu === menuIndex && (
                <ul
                  className={`menu-sub ${
                    activeSubmenu !== null ? "open" : "closed"
                  }`}>
                  {data.submenu.map((val: any, submenuIndex: number) => {
                    return (
                      <li className={`menu-item`} key={submenuIndex}>
                        <Link
                          to={val.path}
                          className={`menu-link text-white`}
                          onClick={() => {
                            setActiveSubmenu(submenuIndex);
                            navigate(val.path);
                          }}>
                          <div className="text-truncate" data-i18n={val.label}>
                            {val.label}
                          </div>
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

export default Sidebar;
